<script setup lang="ts">
const element = useTemplateRef<HTMLElement>('slide');
defineExpose({ element });
defineSlots<{ default: () => void }>();
</script>

<template>
  <swiper-slide ref="slide" class="swiper-slide">
    <slot />
  </swiper-slide>
</template>

<style scoped>
.swiper-slide {
  height: unset;
}
</style>
